<template>
  <div>
    <CompanyInfoBar :companyCode="companyCode" type="solve" :solveInfo="solveInfo"
    @backPress="cancelItem"></CompanyInfoBar>

    <div class="tabs">
      <el-tabs v-model="activeName" class="ly_tabs" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="basicInfo">
          <BasicInfo ref="basicInfo" :queryParams="solveInfo"></BasicInfo>
        </el-tab-pane>

        <el-tab-pane label="方案核心内容" name="planCoreInfo">
          <PlanCoreInfo ref="planCoreInfo"></PlanCoreInfo>
        </el-tab-pane>

        <el-tab-pane label="解决方案服务" name="planService">
          <PlanService ref="planService"></PlanService>
        </el-tab-pane>

        <el-tab-pane label="解决方案资料" name="planReadInfo">
          <PlanReadInfo ref="planReadInfo"></PlanReadInfo>
        </el-tab-pane>

        <el-tab-pane label="实体关联" name="entityConcat">
          <EntityConcat ref="entityConcat"></EntityConcat>
        </el-tab-pane>

        <!-- <el-tab-pane label="标签信息" name="second">
          <label-info
            ref="labelInfo"
            :enterpriseType="enterpriseType"
            :companyId="String(companyCode)"
          />
        </el-tab-pane> -->

        <el-tab-pane label="手动标签" name="third">
          <labelManagement
            ref="labelManagement"
            :enterpriseType="enterpriseType"
            :companyCode="String(companyCode)"
            :companyId="String(companyId)"
          ></labelManagement>
        </el-tab-pane>

        <!-- <el-tab-pane label="半自动化标签" name="four">
          <robotizationlabel
            ref="robotizationlabel"
            :activeId="activeId"
            v-show="headTabActive == 2"
            :companyId="String(companyId)"
            :type="type"
            :companyCode="String(companyCode)"
          ></robotizationlabel>
        </el-tab-pane> -->

        <el-tab-pane label="数据日志" name="dataLog">
          <DataLog></DataLog>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 半自动化标签不展示按钮 -->

    <div
      class="editEnterprise"
      ref="editEnterprise"
      v-if="this.activeName != 'four'"
    >
      <div class="bottom">
        <el-button type="primary" @click="saveItem(activeName)">保存</el-button>
        <el-button @click="cancelItem">取消</el-button>
      </div>
    </div>

    <div
      style="height: 50px; background: #fff; border: 1px solid #EBEEF5"
      v-if="this.activeName == 'four'"
    ></div>
  </div>
</template>

<script>
import {
  updateClientEnterprise,
  insertClientEnterprise,
  getClientEnterpriseOne
} from "@/api/customCompany";
import {
  insertCompanyLabel,
  updateCompanyLabel,
  selectCompanyLabel
} from "@/api/enterprise";
import { savelabel, updateInformationLabel } from "@/api/datement.js";
import UploadImage from "@/components/UploadImage.vue";
import DicRadioGroup from "@/components/DicRadioGroup.vue";
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import CascaderArea from "@/components/CascaderAreaEnter.vue";
import DataTime from "@/components/DataTime.vue";

// 基本信息
import BasicInfo from "./components/BasicInfo.vue";
// 方案核心内容
import PlanCoreInfo from "./components/PlanCoreInfo.vue";
// 方案服务
import PlanService from "./components/PlanService.vue";
// 解决方案资料
import PlanReadInfo from "./components/PlanReadInfo.vue";
// 实体关联
import EntityConcat from "./components/EntityConcat.vue";
// 数据日志
import DataLog from "./components/DataLog.vue";
// 标签信息
import LabelInfo from "./components/labelInfo.vue";
// 手动标签
import labelManagement from "./components/labelManagement.vue";
// 半自动标签
import robotizationlabel from "./components/robotizationlabel.vue";

// 顶部企业信息
import CompanyInfoBar from "@/components/CompanyInfoBar/index.vue";

const defaultEnterpriseInfo = Object.freeze({
  companyOperationalStatus: "", // 运营状态
  companyLogo: "",
  companyLogoLook: "",
  companyShortName: "", // 公司简称
  companyName: "", // 公司名称
  companyFullName: "", // 公司全称
  companyLevel: "", // 专精特新
  industryCategoryList: [], // 行业类别
  industryCategoryChild: [], // 行业类别
  companyBriefIntroduction: "", // 简介
  legalRepresentative: "", // 法人
  registeredCapital: "", // 注册资本
  establishmentDate: "", // 成立日期
  country: "", // 国家
  province: "", // 省份
  city: "", // 城市
  telephone: "", // 电话
  email: "", // 邮箱
  socialSecurityNumber: "", // 社保人数
  formerName: "", // 曾用名
  englishName: "", // 英文名
  website: "", // 网址
  companyAddress: "", // 公司名称
  businessScope: "", // 经营范围
  financingRounds: "", // 融资轮次
  enterpriseScale: "", // 企业规模
  companyLevelType: "", //级别
  certificationYear: "", //认定年份
  region: ""
});

export default {
  name: "customerMain",
  components: {
    UploadImage,
    DicRadioGroup,
    DicCheckboxGroup,
    CascaderArea,
    DataTime,
    LabelInfo,
    BasicInfo,
    PlanCoreInfo,
    PlanService,
    PlanReadInfo,
    EntityConcat,
    DataLog,
    labelManagement,
    robotizationlabel,

    CompanyInfoBar
  },
  data() {
    return {
      isLinkShow: false,
      isShow: false,
      query: {
        judgeArray: [
          { label: "是", value: 1 },
          { label: "否", value: 0 }
        ],
      },
      activeName: "basicInfo",
      isShowInput: false,
      searchBarFixed: false,
      saveCompanyLogo: "",
      teamInfoTable: [], // 团队信息数据
      rulesCompanyInfo: {
        companyFullName: [
          { required: true, message: "请输入公司全称", trigger: "blur" }
        ]
      },
      solveInfo: {
        coverImage: [], // 封面图
        shareImage: [], // 分享图
        dataQuality: "", // 数据质量
        deliveryType: "", // 交付类型
        deliveryTypeList: "", // 交付类型list
        solutionDataIntegrity: "", // 数据完整度
        solutionDisplayLink: "", // 解决方案展示链接
        solutionIllustration: "", // 方案配图
        solutionIllustrationList: [], // 方案配图list
        solutionName: "", // 方案名称
        solutionType: "" // 方案类型
      },
      enterpriseInfo: { ...defaultEnterpriseInfo },
      members: [],
      companyId: "", // 企业主键
      headTabActive: this.$route.query.headTabActive, // tab类名控制
      activeId: this.$route.query.id, // 点击编辑进来的 那一项id
      // companyFullNameRule: false, // 判断公司全称有没有
      allArr: [], //回显的数据
      flag: true //判断是否点击了手动标签去调用了getById这个查询接口,全局只能调用一次
    };
  },
  computed: {
    companyCode() {
      return this.$route.query.companyCode;
    },
    enterpriseType() {
      return Number(this.$route.query.enterpriseType);
    },
    type() {
      return Number(this.$route.query.type);
    }
  },
  watch: {
    "enterpriseInfo.id": {
      handler(newVal) {
        if (this.enterpriseInfo && newVal) {
          this.isShow = true;
        }
      },
      deep: true,
      immediate: true
    },
    // 监听是否在手动标签页面
    activeName: {
      handler(newVal, oldVal) {
        this.getData()
        this.saveItem(oldVal)
      }
    }
  },
  created() {
    // 是编辑才调用查询接口
    if (this.enterpriseType) {
      this.search();
      // this.searchLabel();
    }
    if (!this.enterpriseType) {
      this.isShow = true;
    }
  },
  mounted() {
    document.querySelector(".el-tabs__content").style.minHeight =
      document.body.clientHeight - 368 + "px";

    this.$nextTick(() => {
      this.getData();
    });
  },
  methods: {
    getData() {
      switch (this.activeName) {
        case "basicInfo":
          this.$refs.basicInfo.getInfo();
          break;
        case "planCoreInfo":
          this.$refs.planCoreInfo.getInfo();
          break;
        case "planService":
          this.$refs.planService.getInfo();
          break;
        case "planReadInfo":
          this.$refs.planReadInfo.getInfo();
          break;
        case "entityConcat":
          this.$refs.entityConcat.getInfo();
          break;
      }
    },
    // 切换tabs页(切换到手动标签,调用查询回显的数据)
    handleClick(tab, event) {
      if (tab.index == 2 && (this.companyId || this.companyCode)) {
        this.$refs.labelManagement.getBylabelId();
      }
    },
    updateCode(val, tag) {
      switch (tag) {
        case "行业":
          this.enterpriseInfo.industryCategoryChild = val;
          break;

        case "技术":
          this.enterpriseInfo.techChildrenId = val;
          break;

        default:
          break;
      }
    },
    dateClick(year, month, day) {
      this.enterpriseInfo.year = year;
      this.enterpriseInfo.day = day;
      this.enterpriseInfo.month = month;
    },
    // 查询
    async search() {
      const res = await getClientEnterpriseOne({
        id: this.companyCode
      });

      this.enterpriseInfo = res.data;
      this.enterpriseInfo.oldCompanyFullName = this.enterpriseInfo.companyFullName;

      // this.enterpriseInfo.industryCategoryList = this.formatString(
      //   this.enterpriseInfo.industryCategoryList
      // );
      if (this.enterpriseInfo.industryCategory) {
        this.enterpriseInfo.industryCategoryList = this.formatString(
          this.enterpriseInfo.industryCategory
        );
      } else {
        this.enterpriseInfo.industryCategoryList = [];
      }

      // 查询的时候处理企业资质
      if (this.enterpriseInfo.companyLevel) {
        if (this.enterpriseInfo.companyLevel.includes("/")) {
          this.allArr = this.enterpriseInfo.companyLevel.split("/");
          this.allArr.forEach(item => {
            if (item == "专精特新小巨人") {
              this.$refs.info.checked2 = true;
              this.$refs.info.disone = true;
              this.$refs.info.le = true;
              this.$refs.info.leone = false;
              this.$refs.info.letwo = true;
            } else if (item == "专精特新") {
              this.$refs.info.checked1 = true;
              this.$refs.info.distwo = true;
              this.$refs.info.le = true;
              this.$refs.info.leone = true;
              this.$refs.info.letwo = true;
            } else {
              this.$refs.info.checked3 = true;
            }
          });
        } else if (this.enterpriseInfo.companyLevel.includes("专精特新")) {
          this.$refs.info.checked1 = true;
          this.$refs.info.distwo = true;
          this.$refs.info.le = true;
          this.$refs.info.leone = true;
          this.$refs.info.letwo = true;
        } else if (
          this.enterpriseInfo.companyLevel.includes("专精特新小巨人")
        ) {
          this.$refs.info.checked2 = true;
          this.$refs.info.disone = true;
          this.$refs.info.le = true;
          this.$refs.info.leone = false;
          this.$refs.info.letwo = true;
        } else {
          this.$refs.info.checked3 = true;
        }
      }
    },
    // 将字符串格式化成数组
    formatString(val) {
      if (!val) {
        return [];
      } else if (!val.length) {
        return val;
      } else {
        return val.split(",");
      }
    },
    editClick() {
      this.isShowInput = true;
    },

    // 修改公司全称
    async sureInfo() {
      this.$refs.rulesCompanyInfo.validate(async valid => {
        if (valid) {
          const res = await updateClientEnterprise(this.enterpriseInfo);
          this.isShowInput = false;
        }
      });
    },
    // 新增公司全称和公司logo
    saveCompanyInfo() {
      this.$refs.rulesCompanyInfo.validate(async valid => {
        if (valid) {
          const params = {
            companyAddParam: this.enterpriseInfo,
            members: this.members
          };
          const res = await insertClientEnterprise(params);

          if (res.code === 200) {
            this.$message.success("新增成功");
          }
        }
      });
    },
    // 全部保存
    async saveItem(activeName) {
      switch (activeName) {
        case "basicInfo":
          this.$refs.basicInfo?.submit();
          break;
        case "planService":
          this.$refs.planService?.submit();
          break;
      }
    },
    cancelItem() {
      this.$router.go(-1);
      this.$router.push({
        path: "/solvePlan"
      });
    },
    // 企业标签查询
    async searchLabel() {
      const { data: res } = await selectCompanyLabel({
        companyId: this.companyCode
      });
      this.$refs.labelInfo.companyLabelParam = res;

      // 解决企业标签的关键词至标签编号新增时为空时,输入框不展示
      if (
        !res.companyKeywordAddParamList ||
        !res.companyKeywordAddParamList[0].companyLabelList
      ) {
        this.$refs.labelInfo.companyLabelParam = {
          keywordVersion: "",
          companyKeywordAddParamList: [
            {
              companyLabelList: [
                {
                  groupLabelId: "", // 标签组编号
                  groupLabelName: "", // 标签组名称
                  labelId: "", // 标签编号
                  labelName: "", // 标签内容
                  companyKeywordId: null,
                  superiorLabel: null // 上级标签
                }
              ],
              keyword: "", // 关键词
              keywordDescribe: "" // 关键词数据
            }
          ]
        };
      } else {
        // 如果标签内容有数据的话就将校验关闭
        // this.$refs.labelInfo.rules.labelName[0].required = false;
        this.$refs.labelInfo.companyLabelParam = res;
        // 请求数据回来后，将标签内容也改为（标签组名称+标签内容）
        res.companyKeywordAddParamList.forEach(item => {
          item.companyLabelList.forEach(child => {
            child.labelName = child.groupLabelName + "/" + child.labelName;
          });
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    align-items: center;

    .info {
      margin-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .fullName {
        display: flex;
        align-items: center;
        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #333333;
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  .company_center {
    display: flex;

    .label {
      font-size: 16px;
      color: #333333;
    }

    .company_data {
      margin-right: 45px;

      .value_num {
        margin-top: 8px;
        height: 43px;
        line-height: 43px;
        font-size: 22px;
        font-weight: 500;
        text-align: center;
      }
    }

    .company_circle {
      .circle_content {
        margin-top: 8px;
        width: 43px;
        height: 43px;
      }
    }

    .company_circle,
    .company_data {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .company_right {
    display: flex;

    .back-icon {
      width: 18px;
      height: 18px;
    }

    .context {
      line-height: 18px;
    }

    .company_button {
      display: flex;
      align-items: center;
      font-size: 14px;
    }

    .company_edit_info {
      margin-left: 20px;
      font-size: 14px;
      color: #999999;

      .company_edit_item {
        display: flex;
        align-items: center;

        p {
          height: 20px;
          line-height: 20x;
        }

        img {
          margin-right: 5px;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}

/deep/ .el-tabs__content {
  overflow: auto;
}
.companyInfo {
  background: #fff;
  padding: 20px;
  // margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
  .avatar {
    margin-right: 20px;
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}

// tabs样式
.ly_tabs {
  background: #fff;
  padding: 0 20px;
}
.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 15px;
}
.el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
}
.company .company_left .info .fullName[data-v-92b4247e] {
  margin-bottom: 10px;
}
</style>
